module.exports = __webpack_public_path__ + "img/w3_add_black.3f7f50c2.png";